import { BUTTON_TYPE_LARGE, BUTTON_TYPE_MEDIUM, BUTTON_TYPE_SMALL } from '@modules/editor-sidebar';
import { app } from '@/store';

const setCssStyle = (cssValue: any) => {
  return `${cssValue} !important`;
};

const getValueWithDataUnit = (data: string) => {
  const result: any = data.match(/[a-z]+|[^a-z]+/gi);
  return {
    value: parseFloat(result[0]),
    unit: result[1],
  };
};

// const getButtonDropShadow = (buttonValue: any) => {
//   const radian = parseInt(buttonValue.dropShadow.angle) * (Math.PI / 180);
//   const x = Math.cos(radian) * parseFloat(buttonValue.dropShadow.distance);
//   const y = Math.sin(radian) * parseFloat(buttonValue.dropShadow.distance);
//   const boxShadowValue = `${x}px ${y}px ${buttonValue.dropShadow.blur} ${buttonValue.dropShadow.size} ${buttonValue.dropShadow.color}`;
//   return setCssStyle(boxShadowValue);
// };

const getTextStyle = (presetTexts: any, keyText: string): any => {
  const text = presetTexts.find((item: { key: string }) => item.key == keyText);
  if (text) {
    const textValue = text.value;
    const cssButtonLines: any = {};
    const baseSizeValue = getValueWithDataUnit(textValue.baseSize).value;
    const parseFontSize = getValueWithDataUnit(textValue.fontSize);
    let fontSizePx = parseFontSize.value;
    let fontSizeRem = parseFontSize.value;

    if (parseFontSize.unit == 'rem') {
      fontSizePx *= baseSizeValue;
    } else {
      fontSizeRem /= baseSizeValue;
    }

    const paddingXNumber = fontSizePx;
    const paddingYNumber = fontSizePx / 2 + baseSizeValue / 4;
    const paddingX = paddingXNumber + 'px';
    const paddingY = paddingYNumber + 'px';
    cssButtonLines['paddingLeft'] = setCssStyle(paddingX);
    cssButtonLines['paddingRight'] = setCssStyle(paddingX);
    cssButtonLines['paddingTop'] = setCssStyle(paddingY);
    cssButtonLines['paddingBottom'] = setCssStyle(paddingY);
    cssButtonLines['fontSize'] = setCssStyle(fontSizePx + 'px');
    cssButtonLines['textDecoration'] = setCssStyle(textValue.decoration);
    cssButtonLines['fontStyle'] = setCssStyle(textValue.fontStyle);
    cssButtonLines['fontWeight'] = setCssStyle(textValue.fontWeight);
    const sizeButton = {
      baseSize: baseSizeValue,
      fontSize: fontSizePx,
      fontSizeRem: fontSizeRem,
      paddingX: paddingXNumber,
      paddingY: paddingYNumber,
    };

    return { data: cssButtonLines, sizeButton: sizeButton };
  }
  return false;
};

const getObjMaxSizeButton = (typeButton: any, scaleType: any, sizeButton: any, oldMaxSize: any = {}) => {
  let maxSize: any = {};
  if (oldMaxSize && Object.keys(oldMaxSize).length) {
    if (scaleType === 'preview') {
      return oldMaxSize;
    } else {
      if (sizeButton.fontSize > oldMaxSize.fontSize) {
        maxSize.type = typeButton;
        maxSize.fontSize = sizeButton.fontSize;
        maxSize.baseSize = sizeButton.baseSize;
        return maxSize;
      } else {
        return oldMaxSize;
      }
    }
  } else {
    maxSize = {
      type: typeButton,
      fontSize: sizeButton.fontSize,
      fontSizeRem: sizeButton.fontSizeRem,
      baseSize: sizeButton.baseSize,
    };
    if (scaleType === 'preview') {
      maxSize.height = sizeButton.fontSize + sizeButton.paddingY * 2;
      maxSize.paddingX = sizeButton.paddingX;
      maxSize.paddingY = sizeButton.paddingY;
    }
    return maxSize;
  }
};

const getNewCssObjectScale = (typeButton: string, cssObject: any, ratio: number, baseSize: any): any => {
  if (cssObject && Object.keys(cssObject).length && cssObject[typeButton]) {
    baseSize = baseSize * ratio;
    const fontSizeOld = getValueWithDataUnit(cssObject[typeButton]['fontSize']).value;
    const paddingTopOld = getValueWithDataUnit(cssObject[typeButton]['paddingTop']).value;
    const paddingRightOld = getValueWithDataUnit(cssObject[typeButton]['paddingRight']).value;
    const newFontSize = fontSizeOld * ratio;
    const paddingX = paddingRightOld * ratio;
    const paddingY = paddingTopOld * ratio;
    cssObject[typeButton]['fontSize'] = setCssStyle(newFontSize + 'px');
    cssObject[typeButton]['paddingLeft'] = setCssStyle(paddingX + 'px');
    cssObject[typeButton]['paddingRight'] = setCssStyle(paddingX + 'px');
    cssObject[typeButton]['paddingTop'] = setCssStyle(paddingY + 'px');
    cssObject[typeButton]['paddingBottom'] = setCssStyle(paddingY + 'px');
  }
  return cssObject;
};

const handleResizeButton = (scaleType: any, maxSize: any, maxScreenPx: number, cssObject: any) => {
  if (scaleType === 'preview') {
    const heightButton = maxSize.height;
    if (heightButton > maxScreenPx) {
      const ratio = maxScreenPx / heightButton;
      const fontSizePx = maxSize.fontSize * ratio;
      const paddingX = maxSize.paddingX * ratio;
      const paddingY = maxSize.paddingY * ratio;
      cssObject[maxSize.type]['fontSize'] = setCssStyle(fontSizePx + 'px');
      cssObject[maxSize.type]['paddingLeft'] = setCssStyle(paddingX + 'px');
      cssObject[maxSize.type]['paddingRight'] = setCssStyle(paddingX + 'px');
      cssObject[maxSize.type]['paddingTop'] = setCssStyle(paddingY + 'px');
      cssObject[maxSize.type]['paddingBottom'] = setCssStyle(paddingY + 'px');
    }
  } else {
    const fontSize = maxSize.fontSize;
    if (fontSize > maxScreenPx) {
      const ratio = maxScreenPx / fontSize;
      cssObject = getNewCssObjectScale(BUTTON_TYPE_SMALL, cssObject, ratio, maxSize.baseSizeSmall);
      cssObject = getNewCssObjectScale(BUTTON_TYPE_MEDIUM, cssObject, ratio, maxSize.baseSizeMedium);
      cssObject = getNewCssObjectScale(BUTTON_TYPE_LARGE, cssObject, ratio, maxSize.baseSizeLarge);
    }
  }
  return cssObject;
};

export const convertButtonOptionToCssObject = (button: { value: any }, maxScreenPx = 0, scaleType = 'fontSize') => {
  const currentPresetInPage = (app as any).$store.state['sidebar'].currentPresetInPage;
  if (!currentPresetInPage) return;

  const presetTexts: any = currentPresetInPage['presetOptions'].texts;
  if (!presetTexts) return;

  if (maxScreenPx === 0) {
    if (scaleType == 'fontSize') {
      const offsetWidth = document.body.offsetWidth;
      if (offsetWidth <= 1300) {
        maxScreenPx = 58;
      } else {
        maxScreenPx = 72;
      }
    } else {
      maxScreenPx = 24;
    }
  }

  let cssObject: any = Object({});
  let cssLines: any = {};
  const cssHoverLines: any = {};
  const buttonValue = button.value;
  const classNameButton = 'button';
  const classNameIcon = 'icon';
  // if (buttonValue.dropShadow && buttonValue.dropShadow.enabled) {
  //   cssLines["boxShadow"] = getButtonDropShadow(buttonValue);
  // }
  if (buttonValue.backgroundColor) {
    const bgStyle = buttonValue.backgroundColor.origin
      ? setCssStyle(buttonValue.backgroundColor.origin)
      : 'unset !important';
    cssLines['backgroundColor'] = bgStyle;
    const bgHover = buttonValue.backgroundColor.hover
      ? setCssStyle(buttonValue.backgroundColor.hover)
      : 'unset !important';
    cssHoverLines['backgroundColor'] = bgHover;

    cssLines['backgroundImage'] = 'unset !important';
    cssHoverLines['backgroundImage'] = 'unset !important';
  }

  if (buttonValue.textColor) {
    const clStyle = setCssStyle(buttonValue.textColor.origin);
    cssLines['color'] = clStyle;
    const clHover = setCssStyle(buttonValue.textColor.hover);
    cssHoverLines['color'] = clHover;
  }

  if (buttonValue.iconColor) {
    const iClStyle = setCssStyle(buttonValue.iconColor.origin);
    cssObject[classNameIcon] = {
      color: iClStyle,
    };
    const iClHover = {
      color: setCssStyle(buttonValue.iconColor.hover),
    };
    cssObject[`${classNameIcon}Hover`] = iClHover;
  }

  if (buttonValue.cornerStyle) {
    const currentPresetInPage = (app as any).$store.state['sidebar'].currentPresetInPage;
    if (!currentPresetInPage) return;

    const presetConners: any = currentPresetInPage['presetOptions'].corners;
    if (!presetConners) return;

    const corner = presetConners.find((item: { id: any }) => item.id == buttonValue.cornerStyle);
    if (corner) {
      cssLines['borderRadius'] = setCssStyle(corner.value.value);
    }
  }

  if (buttonValue.borderStyle) {
    const currentPresetInPage = (app as any).$store.state['sidebar'].currentPresetInPage;
    if (!currentPresetInPage) return;

    const presetBorders: any = currentPresetInPage['presetOptions'].borders;
    if (!presetBorders) return;

    const border = presetBorders.find((item: { id: any }) => item.id == buttonValue.borderStyle);
    if (border) {
      const borderValue = border.value;
      let borderStyle = {};
      borderStyle = {
        borderColor: setCssStyle(borderValue.color),
        borderWidth: setCssStyle(borderValue.thickness),
        borderStyle: setCssStyle(borderValue.style),
      };
      cssLines = { ...cssLines, ...borderStyle };
    }
  } else {
    cssLines = { ...cssLines, borderWidth: 0 };
  }

  const textStyle = buttonValue.textStyle;
  let maxSize: any = {};

  if (textStyle) {
    const keyTxtLarge = textStyle.large;
    const keyTxtMedium = textStyle.medium;
    const keyTxtSmall = textStyle.small;
    if (keyTxtSmall) {
      const textStyle = getTextStyle(presetTexts, keyTxtSmall);
      const sizeButton = textStyle.sizeButton;
      if (textStyle) {
        cssObject[BUTTON_TYPE_SMALL] = textStyle.data;
        maxSize = getObjMaxSizeButton(BUTTON_TYPE_SMALL, scaleType, sizeButton);
        maxSize.baseSizeSmall = sizeButton.baseSize;
        maxSize.fontSizeSmall = sizeButton.fontSizeRem;
        cssLines = { ...cssLines, textDecoration: cssObject[BUTTON_TYPE_SMALL]['textDecoration'] };
      }
    }

    if (keyTxtMedium) {
      const textStyle = getTextStyle(presetTexts, keyTxtMedium);
      const sizeButton = textStyle.sizeButton;
      if (textStyle) {
        cssObject[BUTTON_TYPE_MEDIUM] = textStyle.data;
        maxSize = getObjMaxSizeButton(BUTTON_TYPE_MEDIUM, scaleType, sizeButton, maxSize);
        maxSize.baseSizeMedium = sizeButton.baseSize;
        maxSize.fontSizeMedium = sizeButton.fontSizeRem;
        cssLines = { ...cssLines, textDecoration: cssObject[BUTTON_TYPE_MEDIUM]['textDecoration'] };
      }
    }

    if (keyTxtLarge) {
      const textStyle = getTextStyle(presetTexts, keyTxtLarge);
      const sizeButton = textStyle.sizeButton;
      if (textStyle) {
        cssObject[BUTTON_TYPE_LARGE] = textStyle.data;
        maxSize = getObjMaxSizeButton(BUTTON_TYPE_LARGE, scaleType, sizeButton, maxSize);
        maxSize.baseSizeLarge = sizeButton.baseSize;
        maxSize.fontSizeLarge = sizeButton.fontSizeRem;
        cssLines = { ...cssLines, textDecoration: cssObject[BUTTON_TYPE_LARGE]['textDecoration'] };
      }
    }
    cssObject = handleResizeButton(scaleType, maxSize, maxScreenPx, cssObject);
  }
  cssObject[classNameButton] = cssLines;
  cssObject[`${classNameButton}Hover`] = cssHoverLines;
  return cssObject;
};
